import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "row"]
  static values = { itemId: Number }

  add() {
    const index = this.rowTargets.length
    const itemId = this.itemIdValue
    const html = `
      <div class="flex gap-2 mb-1" data-ocr-variants-target="row">
        <input type="text" name="items[${itemId}][variants][${index}][name]"
               class="w-24 border border-gray-300 rounded px-2 py-1 text-sm"
               placeholder="サイズ名">
        <input type="number" name="items[${itemId}][variants][${index}][price]"
               class="w-24 border border-gray-300 rounded px-2 py-1 text-sm"
               placeholder="価格">
        <button type="button" data-action="ocr-variants#remove"
                class="text-red-400 hover:text-red-600 text-sm">×</button>
      </div>
    `
    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    const row = event.target.closest("[data-ocr-variants-target='row']")
    if (row) row.remove()
    this.reindex()
  }

  reindex() {
    const itemId = this.itemIdValue
    this.rowTargets.forEach((row, index) => {
      const nameInput = row.querySelector("input[type='text']")
      const priceInput = row.querySelector("input[type='number']")
      if (nameInput) nameInput.name = `items[${itemId}][variants][${index}][name]`
      if (priceInput) priceInput.name = `items[${itemId}][variants][${index}][price]`
    })
  }
}
